import styled from "styled-components";
import { useTranslation } from "react-i18next";

import {
  Table,
  TableHead,
  TableHeadCell,
  TableHeadRow,
} from "../PlaceTable/TableStyle";
import { Version } from "../../models";

import VersionHistoryRow from "./VersionHistoryRow";

const VersionHeadRow = styled(TableHeadRow)`
  grid-template-columns: 1.4fr repeat(3, 1.4fr);
`;

type Props = {
  artifactId: string;
  versionList: Version[];
  label: string;
};

const VersionHistoryTable = ({
  artifactId,
  versionList,
  label,
}: Props): JSX.Element => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <VersionHeadRow>
          <TableHeadCell hideColumn>
            {t("version.table_header.version_id")}
          </TableHeadCell>
          <TableHeadCell>{t("version.table_header.milestone")}</TableHeadCell>
          <TableHeadCell>{t("version.table_header.comments")}</TableHeadCell>
          <TableHeadCell hideColumn>
            {t("version.table_header.created_by")}
          </TableHeadCell>
          <TableHeadCell>{t("version.table_header.created_on")}</TableHeadCell>
          <TableHeadCell />
        </VersionHeadRow>
      </TableHead>
      {versionList.map((version) => (
        <VersionHistoryRow
          artifactId={artifactId}
          version={version}
          key={version.versionId}
          label={label}
        />
      ))}
    </Table>
  );
};

export default VersionHistoryTable;
